module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Angle Grinder-c6a573a8399409b017490061da3063d0.svg";